import(/* webpackMode: "eager" */ "D:\\WORK\\ahli SEO\\Code\\ahliseo-frontend\\node_modules\\next\\dist\\client\\image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\WORK\\ahli SEO\\Code\\ahliseo-frontend\\node_modules\\next\\dist\\client\\link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\WORK\\ahli SEO\\Code\\ahliseo-frontend\\src\\app\\tentang-kami\\CTASection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\WORK\\ahli SEO\\Code\\ahliseo-frontend\\src\\components\\common\\Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\WORK\\ahli SEO\\Code\\ahliseo-frontend\\src\\components\\common\\Header.tsx");
